import { connect } from 'react-redux'

import { TableBodyCell } from 'react-wot-bootstrap'

import { userContextMenu } from 'state/actions/CMT/ContextMenu'

const mapDispatchToProps = (dispatch, ownProps) => ({
    onContextMenu() {
        if (ownProps.onContextMenu) ownProps.onContextMenu()
        dispatch(userContextMenu(ownProps.id)).then(ownProps.onContextMenuItemSelected)
    },
})

export default connect(null, mapDispatchToProps)(TableBodyCell)



// WEBPACK FOOTER //
// ./containers/ClanManagement/containers/TableBodyCellWithCM.js